module.exports = "# Crop and Resize Images Online\r\n\r\nCrop, resize, flip, or rotate an image by uploading it below."


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/image-resize-header.md
// module id = 1177
// module chunks = 0